import React from 'react';
import { css } from 'registration-flow-v2';
import * as styles from './preprod-sign-in.css';

const PreprodSignInHeading = (): JSX.Element => (
  <>
    <h2 className={css(styles.cardHeading)()}>Sign in to Pre-Production</h2>
    <div className={css(styles.calloutBox)()}>
      <div>
        This is the testing environment for the GoodHuman team and trusted partners. To work with your live customers
        and bookings,{' '}
        <a className={css(styles.calloutLink)()} href='https://login.goodhuman.me/login'>
          sign in to your live environment →
        </a>
      </div>
    </div>
  </>
);

export default PreprodSignInHeading;
